/*
 * 自动外呼记录
 *
 * *
 * */
import { ticketClient } from "@/api/ticketClient";
import { AutoCallCoreReq, AutoCallParams } from "@/pbjs/xcommon/ticket_pb";
import { Page } from "@/utils/index";
import { setPage } from "@/utils/request";
import InnerRequest from "./request";

export interface Options {
  Page: Page;
  accountId?: string; // 用户账号
  orderId?: string; //订单号
  calledMobile?: string; //被叫手机号
  showMobile?: string; //外显手机号
  supplier?: string;
  createCallTimeRange?: string;  //呼叫创建的时间范围
  trueCallTimeRange?: string; // 真实外呼开始时间范围
}
export function getDialListReq(arg: Options) {
  let request: any = new AutoCallCoreReq();
  let requestAuto: any = new AutoCallParams();
  request.setPagein(setPage(arg.Page.pageIndex, arg.Page.pageSize));
  requestAuto.setSupplier(arg.supplier);
  requestAuto.setAccountid(arg.accountId);
  requestAuto.setOrderid(arg.orderId);
  requestAuto.setCalledmobile(arg.calledMobile);
  requestAuto.setShowmobile(arg.showMobile);
  requestAuto.setCreatecalltimerange(arg.createCallTimeRange);
  requestAuto.setTruecalltimerange(arg.trueCallTimeRange);
  request.setParams(requestAuto);
  return request;
}
export const getDialListRequest = new InnerRequest(
  ticketClient,
  ticketClient.getAutoCallDetailResult
);